import type { ReactElement, ReactNode } from 'react';
import './DesignSystem.css';

export interface DarkSectionHeaderProps {
  readonly title: string;
  readonly subtitle?: string;
  /** Right-aligned summary metric, e.g. "326 markets". */
  readonly summary?: string;
  readonly children?: ReactNode;
  readonly ariaLabel?: string;
}

/** White section wrapper with a charcoal header bar: down-arrow badge, title, subtitle and a summary metric. */
export function DarkSectionHeader({ title, subtitle, summary, children, ariaLabel }: DarkSectionHeaderProps): ReactElement {
  return (
    <section className="fl-dark-section" aria-label={ariaLabel ?? title}>
      <header className="fl-dark-head">
        <span className="fl-dark-icon" aria-hidden="true">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M7 2.5v9M3 7.5l4 4 4-4" />
          </svg>
        </span>
        <div className="fl-dark-titles">
          <h3 className="fl-dark-title">{title}</h3>
          {subtitle !== undefined && <p className="fl-dark-subtitle">{subtitle}</p>}
        </div>
        {summary !== undefined && <span className="fl-dark-summary">{summary}</span>}
      </header>
      {children !== undefined && <div className="fl-dark-body">{children}</div>}
    </section>
  );
}
